module.exports = __webpack_public_path__ + "static/media/ios-leaf.affb9606.svg";